(function () {
    'use strict'

    var controller = function ($element, $timeout) {
        var ctrl = this;

        //Internal variables
        var _init = false;
        var _f = 'function';

        ctrl.ux = {
            searching: false,
            searchStr: '',
            modelStr: '',
            addNew: false,
            showNewBtn: true,
            listIndex: null,
        };

        ctrl.results = [];

        //Init function
        ctrl.$onInit = init;
        ctrl.$onChanges = changes;
        ctrl.$onDestroy = destroy;

        //-
        function _clickOff(event) {
            if (!event.target.closest("searchfield")) {
                $timeout(function () {
                    ctrl.results = [];
                    ctrl.ux.showNewBtn = false;
                });
                document.removeEventListener('click', _clickOff);
            }
        }

        ctrl.searchFieldFocus = function () {
            if (!ctrl.disabled) {
                if (ctrl.ux.searchStr && ctrl.ux.searchStr.length) ctrl.searchField();
            }
        };

        ctrl.searchField = function (event) {
            if (!ctrl.disabled) {
                document.addEventListener('click', _clickOff);
                if (event?.key === 'ArrowDown') {
                    if (ctrl.results.length || (!ctrl.noAdd && ctrl.ux.showNewBtn)) {
                        $element.find('.results').focus();
                        ctrl.ux.listIndex = 0;
                    }
                } else {
                    if (!!ctrl.externalSearch) {
                        ctrl.ux.searching = true;
                    } else {
                        if (ctrl.list) {
                            var fullArr = [];
                            var searchStr = ctrl.ux.searchStr;
                            if (!!searchStr && searchStr.length) {
                                var splitArr = searchStr.replace(/[,\/#!$%\^&\*;:{}\\\[\]=+\-_<>?'"`~()]/g, '').split(' ');
                                fullArr = ctrl.list;
                                for (var str of splitArr) {
                                    if (str.length) {
                                        var rE = new RegExp(str, 'i');
                                        var filterArr = fullArr.filter(function (fli) {
                                            if (!!ctrl.searchIn) {
                                                for (var prop of ctrl.searchIn) {
                                                    //console.log('prop', prop, fli[prop], 'rE', rE)
                                                    return !!fli[prop] && fli[prop].match(rE);
                                                }
                                            } else {
                                                return !!fli && typeof (fli.match) == _f && fli.match(rE);
                                            }
                                        });
                                        fullArr = [...filterArr];
                                    }
                                }
                            }
                            //Create a new Set to remove duplicate results and immediately spread the Set into an array.
                            ctrl.results = [...new Set(fullArr)];
                        }
                    }
                    ctrl.ux.showNewBtn = true;

                    if (typeof ctrl.onSearch === 'function') ctrl.onSearch({ $event: { type: ctrl.type || null, string: ctrl.ux.searchStr || '' } });
                }
            }
        };

        ctrl.resultsKeyUp = function (event) {
            if (!ctrl.disabled) {
                //console.log('key', event.key, ctrl.ux.listIndex, ctrl.results.length)
                event.preventDefault();
                switch (event.key) {
                    case 'ArrowUp':
                        if (ctrl.ux.listIndex > 0) {
                            ctrl.ux.listIndex--;
                        } else {
                            var offset = (!ctrl.noAdd && ctrl.ux.showNewBtn) ? 0 : -1;
                            ctrl.ux.listIndex = ctrl.results.length - offset;
                        }
                        break;
                    case 'ArrowDown':
                        var offset = (!ctrl.noAdd && ctrl.ux.showNewBtn) ? 1 : 0;
                        if (ctrl.ux.listIndex < ctrl.results.length) {
                            ctrl.ux.listIndex++;
                        } else {
                            ctrl.ux.listIndex = 0;
                        }
                        break;
                    case 'Enter':
                        if (!ctrl.results.length || ctrl.ux.listIndex === ctrl.results.length) {
                            ctrl.setNewAB();
                        } else {
                            ctrl.selectAB(ctrl.results[ctrl.ux.listIndex]);
                        }
                        $element.find('input').focus();
                        break;
                }
            }
        };

        ctrl.selectAB = function (item) {
            if (!ctrl.disabled) {
                ctrl.ux.searchStr = !!ctrl.labelProperty ? item[ctrl.labelProperty] : item;
                ctrl.results = [];
                ctrl.ux.showNewBtn = false;

                if (typeof ctrl.onSelect === 'function')
                    ctrl.onSelect({ $event: { item: item, type: ctrl.type } });
            }
        };

        ctrl.setNewAB = function () {
            if (!ctrl.disabled) {
                ctrl.ux.addNew = true;
                ctrl.results = [];

                if (typeof ctrl.onAddNew === 'function')
                    ctrl.onAddNew({ $event: { string: ctrl.ux.searchStr, type: ctrl.type } });
            }
        };

        function changes(changes) {
            // console.log('_init', _init, 'changes', changes);
            if (_init) {
                if (changes.list && !ctrl.searchIn) {
                    ctrl.ux.searching = false;
                    ctrl.results = angular.copy(ctrl.list);
                }
                if (changes.inputString) {
                    ctrl.ux.searchStr = ctrl.inputString || '';
                    ctrl.ux.showNewBtn = false;
                }
            }
        }

        function init() {
            //set up defaults
            ctrl.ux.searchStr = ctrl.inputString || '';
            if (!!ctrl.ux.searchStr?.length) ctrl.ux.showNewBtn = false;

            _init = true;
        }

        function destroy() {
            document.removeEventListener('click', _clickOff);
            //console.log('Searchfield destroyed');
        }
    };

    app.component('searchfield', {

        bindings: {
            list: '<?',// List to search

            inputString: '<?',// Externally set starting value for search input

            type: '@?',// Type string for parent controller callback routing

            searchIn: '<?',// Property names to search against
            labelProperty: '@?',// Label to show in results list

            required: '<?',

            placeholder: '<?',

            disabled: '<?', // Text input is disabled

            limitText: '@?',

            noAdd: '<?',

            externalSearch: '<?',

            maxHeight: '@?',

            onSearch: '&?',
            onAddNew: '&?',
            onSelect: '&?',
        },

        controller: ['$element', '$timeout', controller],
        controllerAs: 'ctrl',

        templateUrl: (typeof (tios) !== 'undefined' ? tios.util.cdnUrl('dist/angular/component/searchfield.html') : 'component/searchfield.html')
    });
})();